import React from 'react';

import type { AccordionItemId, OpenSections } from '../models';

interface IAccordionHeaderProps {
  onToggled: (index: AccordionItemId, isClickedToggle?: boolean) => void;
  itemId: AccordionItemId;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  openSections: OpenSections;
  tabIndex?: number;
}

class AccordionHeader extends React.PureComponent<IAccordionHeaderProps> {
  componentDidMount() {
    const { defaultOpen = false, onToggled, itemId } = this.props;

    if (defaultOpen) {
      onToggled(itemId);
    }
  }

  componentDidUpdate(prevProps: any) {
    const { onToggled, itemId } = this.props;

    if (prevProps && prevProps.defaultOpen !== this.props.defaultOpen) {
      onToggled(itemId);
    }
  }

  render() {
    const { itemId, onToggled, openSections, className = '', children, tabIndex = 0 } = this.props;

    const isOpen = !!openSections[itemId];

    return (
      <button
        id={`accordion__header__${itemId}`}
        aria-controls={`accordion__body__${itemId}`}
        aria-expanded={`${isOpen}`}
        className={className}
        onClick={() => onToggled(itemId, true)}
        tabIndex={tabIndex}
      >
        {children}
      </button>
    );
  }
}

export { IAccordionHeaderProps as AccordionHeaderProps, AccordionHeader };
